export enum ServiceTypeAbbreviations {
    UTE                       = 'UTE',
    Rigid                     = 'Rigid',
    TwoTonne4P                = '2T4P',
    TwoTonne6P                = '2T6P',
    SemiPMOnly                = 'SemiPM',
    SemiPMWithTrailers        = 'Semi',
    BDoublePMOnly             = 'BDPM', 
    BDoublePMWithTrailers     = 'BDBL',
    ATrailer                  = 'A Trailer', 
    SixTonne8P                = '6T8P', 
    SixTonne10P               = '6T10P', 
    EightTonne12P             = '8T12P', 
    TwelveTonne12P            = '12T12P', 
    TwelveTonne14P            = '12T14P', 
    RoadTrain                 = 'Road Train', 
    BTrailer                  = 'B Trailer', 
    BDoublePMWithATrailer     = 'BDPM+A',
    BDoublePMWithBTrailer     = 'BDPM+B', 
    TenPalletRigid            = '10PR'
}